import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dbd65a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd65a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbd65a0')) {
      api.createRecord('0dbd65a0', component.options)
    } else {
      api.reload('0dbd65a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dbd65a0&scoped=true", function () {
      api.rerender('0dbd65a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadPicture/uploadFrom/index.vue"
export default component.exports